// data/languages/peul/categories/famille.ts

import { CategoryData } from '../../../../types/types';

export const famille: CategoryData = {

  'Neene': { translation: 'Mère', translationEn: 'Mother', audio: 'Ff-Nene', illustration: '👩🏿' },
  'Baaba': { translation: 'Père', translationEn: 'Father', audio: 'Ff-Baba', illustration: '👨🏿' },
 'Yettoore': { translation: 'Nom', translationEn: 'Name', audio: 'Ff-Yettoore', illustration: '' },
  'Innde': { translation: 'Prénom', translationEn: 'First name', audio: 'Ff-Innde', illustration: '' },
 'Giggol': { translation: 'Amour', translationEn: 'Love', audio: 'Ff-Giggol', illustration: '' },
   'Miññiraawo debbo': { translation: 'Sœur', translationEn: 'Sister', audio: 'Ff-Minniraawo_debbo', illustration: '' },
  'Miññiraawo gorko': { translation: 'Frère', translationEn: 'Brother', audio: 'Ff-Minniraawo_gorko', illustration: '👨🏿' },

  'Pati': { translation: 'Grand-mère', translationEn: 'Grandmother', audio: 'Ff-Pati', illustration: '👵🏿' },
  'Soro': { translation: 'Grand-père', translationEn: 'Grandfather', audio: 'Ff-Soro', illustration: '👴🏿' }, // Simplifié
  'Yaaye (paternelle)': { translation: 'Tante', translationEn: 'Aunt', audio: 'Ff-Yaaye', illustration: '👩🏿' },
  'Bappa (paternelle)': { translation: 'Oncle', translationEn: 'Uncle', audio: 'Ff-Bappa', illustration: '👨🏿' },
 'Kaawu (maternelle)': { translation: 'Oncle', translationEn: 'Uncle', audio: 'Ff-Kaawu', illustration: '👨🏿' },
   'Neene tosokko (maternelle)': { translation: 'Tante', translationEn: 'Aunt', audio: 'Ff-Neene_tosokko', illustration: '👩🏿' },

 ' Baadiraawo (niece)': { translation: 'Nièce', translationEn: 'Niece', audio: 'Ff-Baadiraawo', illustration: '👩🏿' },
  ' Baadiraawo (neveu)': { translation: 'Neveu', translationEn: 'Nephew', audio: 'Ff-Baadiraawo', illustration: '👩🏿' },



  'Suudu': { translation: 'Maison', translationEn: 'House', audio: 'Ff-Suudu', illustration: '' },
  'Mojobere': { translation: 'Groupe', translationEn: 'Group', audio: 'Ff-Mojobere', illustration: '' },
  'Saare': { translation: 'Ville', translationEn: 'Town', audio: 'Ff-Saare', illustration: '' },
  'Fulawaa': { translation: 'Village', translationEn: 'Village', audio: 'Ff-Fulawaa', illustration: '' },




  'Paykun': { translation: 'Enfant', translationEn: 'Child', audio: 'Ff-Paykun', illustration: '' },
   'Weldijo': { translation: 'Ami', translationEn: 'Friend', audio: 'Ff-Weldijo', illustration: '' },
    'Faybe': { translation: 'Des enfants', translationEn: 'Children', illustration: '' },
   'Jiwo': { translation: 'Jeune femme', translationEn: 'Young woman', audio: 'Ff-Jiwo', illustration: '' },
  'Jiwbe': { translation: 'Des filles', translationEn: 'Girls', audio: 'Ff-Jiwbe', illustration: '' },
   'Suka': { translation: 'Jeune homme', translationEn: 'Young man', audio: 'Ff-Suka', illustration: '' },
   'Biddo': { translation: 'Enfant de', translationEn: 'Child of', audio: 'Ff-Biddo', illustration: '' },
   'Beynguure': { translation: 'Famille', translationEn: 'Family', audio: 'Ff-Beynguure', illustration: '' },
     'Ko biddo Musa': { translation: 'L\'enfant de Musa', translationEn: 'Musa\'s child', audio: 'Ff-Ko_biddo_musa', illustration: '' },

   'Taaniraawo_debbo': { translation: 'Petite-fille', translationEn: 'Granddaughter', illustration: '' },
  'Taaniraawo_gorko': { translation: 'Petit-fils', translationEn: 'Grandson', audio: 'Ff-Taaniraawo_gorko', illustration: '' },
   'Funeejo': { translation: 'Jumeau', translationEn: 'Twin', audio: 'Ff-Funeejo', illustration: '' },
    'Esiraawo debbo': { translation: 'Belle-mère', translationEn: 'Mother-in-law', audio: 'Ff-Esiraawo debbo', illustration: '' },
    'Esiraawo gorko': { translation: 'Beau-père', translationEn: 'Father-in-law', audio: 'Ff-Esiraawo gorko', illustration: '' },







  'Gorko': { translation: 'Mari/Homme', translationEn: 'Husband/Man', audio: 'Ff-Gorko', illustration: '🤵🏿' },
  'Debbo': { translation: 'Épouse/Femme', translationEn: 'Wife/Woman', audio: 'Ff-Debbo', illustration: '👰🏿' },
  'Sonnaajo': { translation: 'Épouse', translationEn: 'Wife', audio: 'Ff-Sonnaajo', illustration: '👫🏿' },
  'Moodibbo': { translation: 'Époux', translationEn: 'Husband', audio: 'Ff-Moodibbo', illustration: '👫🏿' },


  // ENFANTS ET DESCENDANTS
  'Ɓiɗɗo': { translation: 'Enfant', translationEn: 'Child', audio: 'Ff-Biddo', illustration: '👶🏿' },
  'Ɓiɗɗo gorko': { translation: 'Fils', translationEn: 'Son', audio: 'Ff-Biddo_gorko', illustration: '👦🏿' },
  'Ɓiɗɗo debbo': { translation: 'Fille', translationEn: 'Daughter', audio: 'Ff-Biddo_debbo', illustration: '👧🏿' },

  // PETITS-ENFANTS
  'Janniraawo': { translation: 'Petit-enfant', translationEn: 'Grandchild', illustration: '👶🏿' }, // Corrigé de Taaniraawo


  // BEAUX-PARENTS ET FAMILLE ÉLARGIE
  'Baaba gorko': { translation: 'Beau-père', translationEn: 'Father-in-law', illustration: '👨🏿' },
  'Neene debbo': { translation: 'Belle-mère', translationEn: 'Mother-in-law', illustration: '👩🏿' },
  'Ɓiy-yaawɓe': { translation: 'Famille élargie', translationEn: 'Extended family', illustration: '👥' }
};

export default famille;

export {};
